import React, { useState, useEffect } from "react";
import MenuNovoSuperior from "../menuSuperior/MenuNovoSuperior";
import  {api2}  from "../../api";

const formatCurrency = (v) =>
    v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const getStatus = (percentual) => {
    if (percentual >= 100) {
        return { color: "#22C55E", bg: "#DCFCE7", text: "Meta atingida" };
    }
    if (percentual >= 90) {
        return { color: "#F59E0B", bg: "#FEF3C7", text: "Quase lá" };
    }
    return { color: "#f82727", bg: "#FEE2E2", text: "Não atingiu" };
};

const getBgBar = (value) => {
    if (value >= 100) {
        return { bg:"#bbbfc1"};
    }
    if (value >= 90) {
        return "#bbbfc1";
    }
    return "#bbbfc1";
};

const ProgressBar = ({ value, color }) => (
    <div className="flex items-center gap-3">
        <div className="flex-1 h-[6px] rounded-full overflow-hidden" style={{ backgroundColor: getBgBar(value) }}>
            <div
                className="h-[6px] rounded-full"
                style={{ width: `${value}%`, background: color }}
            />
        </div>
        <span className="text-[13px] text-[#292C30] font-medium semibold">
            {value}%
        </span>
    </div>
);

const StatusBadge = ({ status }) => (
    <div
        className="text-white text-[12px] px-4 py-[6px] rounded-full w-fit semibold"
        style={{ background: status.color }}
    >
        {status.text}
    </div>
);

const Card = ({ item }) => {
    const status = getStatus(item.percentual);

    return (
        <div
            className="rounded-[16px] shadow-sm border p-4 flex flex-col gap-3"
            style={{
                backgroundColor: status.bg,
                borderColor: status.color + "33",
            }}
        >
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center text-[13px] font-semibold text-[#334155]">
                        {item.id}
                    </div>
                </div>
                <span className="text-[#1F2937] text-[24px] font-bold">
                    {formatCurrency(item.venda)}
                </span>
            </div>

            <div className="text-[16px] text-[#374151] font-semibold mb-0">
                <p className="m-0">Meta: {formatCurrency(item.meta)}</p>
                <p className="m-0" style={{ color: status.color }}>
                    Diferença: {formatCurrency(item.diferenca)}
                </p>
            </div>

            <ProgressBar value={item.percentual} color={status.color} />
            <StatusBadge status={status} />
        </div>
    );
};

export default function DashboardMetas() {

    const formatDate = (date) => {
        const offset = date.getTimezoneOffset();
        const local = new Date(date.getTime() - offset * 60000);
        return local.toISOString().split("T")[0];
    };

    const getHoje = () => formatDate(new Date());

    const getInicioMes = () => {
        const hoje = new Date();
        return formatDate(new Date(hoje.getFullYear(), hoje.getMonth(), 1));
    };

    const [dataInicio, setDataInicio] = useState(getHoje());
    const [dataFim, setDataFim] = useState(getHoje());
    const [cards, setCards] = useState([]);
    const [resumo, setResumo] = useState(null);
    const [loading, setLoading] = useState(true);

    const tratarDados = (apiLojas, apiResumo) => {
        const lojas = apiLojas.filter((l) => l.loja_num !== 99);

        const cardsTratados = lojas.map((l) => {
            const meta = l.meta_diaria || 0;
            const venda = l.total || 0;
            const percentual = meta > 0 ? parseFloat((venda / meta) * 100).toFixed(2) : 0;

            return {
                id: l.lojas_nome,
                meta,
                venda,
                diferenca: l.diferenca_valor || venda - meta,
                percentual,
            };
        });

        const totalMeta = lojas.reduce((acc, l) => acc + (l.meta_diaria || 0), 0);
        const totalVenda = lojas.reduce((acc, l) => acc + (l.total || 0), 0);

        const resumoTratado = {
            meta: totalMeta,
            venda: totalVenda,
            diferenca: totalVenda - totalMeta,
            percentual:
                totalMeta > 0
                    ? parseFloat((totalVenda / totalMeta) * 100).toFixed(2)
                    : 0,
            metaMensal: apiResumo[0]?.meta_mensal || 0,
        };

        setCards(cardsTratados);
        setResumo(resumoTratado);
        setLoading(false);
    };

    const getArray = (data) => {
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        if (Array.isArray(data?.result)) return data.result;
        return [];
    };

    const fetchData = async () => {
        try {

            const [res1, res2] = await Promise.all([
                api2.get("/MetasBuscaVendasPeriodo", {
                    params: { data_ini: dataInicio, data_fim: dataFim },
                }),
                api2.get("/MetasBuscaMetaMensalTotal", {
                    params: { data_ini: dataInicio, data_fim: dataFim },
                }),
            ]);

            tratarDados(getArray(res1.data), getArray(res2.data));
        } catch (error) {
            console.error("Erro na API:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        
        <div className="min-h-screen bg-[#F3F4F6]">
            <MenuNovoSuperior />

            <div className="max-w-[1100px] mx-auto px-3 py-3">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-3 text-center md:text-left">
                    <h2 className="text-[26px] font-semibold">
                        Acompanhe suas metas
                    </h2>

                    <div className="flex flex-col md:flex-row gap-3">
                        <input
                            type="date"
                            value={dataInicio}
                            onChange={(e) => setDataInicio(e.target.value)}
                            className="w-full md:w-auto border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />

                        <input
                            type="date"
                            value={dataFim}
                            onChange={(e) => setDataFim(e.target.value)}
                            className="w-full md:w-auto border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                        <button className="bg-[linear-gradient(90deg,#007bff_0%,#66b2ff_100%)] text-white py-2 px-4 rounded-md hover:bg-[#0056b3] transition-colors duration-200" onClick={fetchData}>
                            Filtrar
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {cards.map((item) => (
                        <Card key={item.id} item={item} />
                    ))}
                </div>

                {resumo && (() => {
                    const statusResumo = getStatus(resumo.percentual);
                    return (
                        <div className="bg-white rounded-[16px] font-semibold mt-6 p-4">
                            <p className="m-0 text-[24px] font-bold">Venda: {formatCurrency(resumo.venda)}</p>
                            <p className="m-0">Meta: {formatCurrency(resumo.meta)}</p>
                            <p className="m-0" style={{ color: statusResumo?.color }}>Diferença: {formatCurrency(resumo.diferenca)}</p>

                            <ProgressBar
                                value={resumo.percentual}
                                color="#007bff"
                            />

                            <p className="text-sm mt-2 font-semibold">
                                Meta mensal:{" "}
                                {formatCurrency(resumo.metaMensal)}
                            </p>
                        </div>
                    );
                })()}
            </div>
        </div>
    );
}